import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import ExpenseFormItem, { ExpenseFormInput } from '../ExpenseWidget/ExpenseFormItem';
import moment from 'moment';
import RowView from '../RowView';
import { useNavigation, useRoute } from '@react-navigation/core';
import { Modals } from '../../constants/ScreenNames';
import { widgetStyles } from '../../styles/theme';

const EventFormWidget = ({ state, sideState, openCalendar, dispatch }) => {
  const navigation = useNavigation();
  const route = useRoute();
  const { isVirtual } = state;

  return (
    <View style={styles.widgetContainer}>
      <ExpenseFormInput
        label="Event Name"
        value={state?.name}
        onChangeText={(text) => {
          dispatch({ type: 'name', value: text });
        }}
        icon={state?.name ? null : 'event'}
      />
      {state.isAir || state.isHotel ? (
        <TouchableOpacity
          onPress={() =>
            navigation.navigate(Modals.StationAutoCompleteModal, {
              returnScreen: route.name,
              source: 'to',
              index: 0,
              hasHotel: false,
              hasAir: true,
              inputName: 'setEventCity',
            })
          }
        >
          <ExpenseFormItem
            label={
              sideState.isOnlyAir || (sideState.isAirDominant && !state.isHotel)
                ? 'Event City or Airport'
                : sideState.isDriveOrVirtual
                ? 'City, Location or Hotel'
                : 'Event City, Location or Hotel'
            }
            value={state?.city ? state.city?.displaylabel : null}
            icon={state?.city ? null : state.isHotel ? 'hotel' : 'flight'}
            style={widgetStyles.topBorder}
          />
        </TouchableOpacity>
      ) : null}
      {state.isDrive ? (
        <TouchableOpacity
          onPress={() =>
            navigation.navigate(Modals.StationAutoCompleteModal, {
              returnScreen: route.name,
              source: 'to',
              index: 0,
              hasHotel: false,
              hasAir: true,
              inputName: 'setEventVenue',
            })
          }
        >
          <ExpenseFormItem
            label="Venue Address or Name"
            value={state?.venue ? state.venue?.displaylabel : null}
            icon={state?.venue ? null : 'mark'}
            style={widgetStyles.topBorder}
          />
        </TouchableOpacity>
      ) : null}
      {isVirtual ? (
        <ExpenseFormInput
          label="Virtual Link"
          value={state?.virtualLink}
          onChangeText={(value) => dispatch({ type: 'virtualLink', value })}
          icon={state?.virtualLink ? null : 'link'}
          style={widgetStyles.topBorder}
        />
      ) : null}
      <TouchableOpacity onPress={openCalendar}>
        <ExpenseFormItem
          label="Start - End"
          value={
            state?.startDate && state?.endDate
              ? `${moment(state.startDate).format('MMM DD')} - ${moment(state.endDate).format(
                  'MMM DD'
                )}`
              : null
          }
          icon={state?.startDate && state?.endDate ? null : 'calendar'}
          style={widgetStyles.topBorder}
        />
      </TouchableOpacity>
      <RowView style={widgetStyles.topBorder}>
        <TouchableOpacity
          style={CommonStyles.halfWidth}
          onPress={() =>
            navigation.navigate(Modals.TimePickerModal, {
              returnScreen: route.name,
              selectedTimes: {
                startTime: state.startTime,
              },
              oneTime: true,
              inputName: 'startTime',
            })
          }
        >
          <ExpenseFormItem
            label="Start"
            icon={state.startTime ? null : 'time'}
            value={state.startTime ? state.startTime.displayName : null}
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={widgetStyles.time}
          onPress={() =>
            navigation.navigate(Modals.TimePickerModal, {
              returnScreen: route.name,
              selectedTimes: {
                startTime: state.endTime,
              },
              oneTime: true,
              inputName: 'endTime',
            })
          }
        >
          <ExpenseFormItem
            label="End"
            icon={state?.endTime ? null : 'time'}
            value={state.endTime ? state.endTime.displayName : null}
          />
        </TouchableOpacity>
      </RowView>
    </View>
  );
};

const styles = StyleSheet.create({
  widgetContainer: {
    backgroundColor: Color.accent,
    ...CommonProperties.mt2,
    ...CommonProperties.mb3,
    ...CommonProperties.borderRadius3,
    ...CommonProperties.shadow,
  },
});

export default EventFormWidget;
